module.exports = __webpack_public_path__ + "img/img_ser.f03b1edc_f03b1edc63f6bb73bb5fa3252c0f34c3.f03b1edc.png";